/**
 * Size spec for the admin shell header — the one bar every admin product area renders above its
 * content. The unified website editor's chrome is the reference: product direction is that every
 * other area matches its bar height and the sizes of its hamburger, logo and title rather than
 * each area carrying its own. Change a value here and every shell surface follows; don't
 * re-declare these numbers locally.
 */

/** Height of the shell's top bar row (px). The website editor's left-panel nav row and the top
 *  bar above its preview both sit at this height, so their bottom borders line up across the
 *  panel divider. */
export const ADMIN_SHELL_BAR_HEIGHT = 64;

/** Horizontal inset of the brand row, as a theme space-scale index (5 = 16px). */
export const ADMIN_SHELL_BRAND_PADDING_X = 5;

/** Gap between the hamburger + logo cluster and the title, and between the hamburger and the
 *  logo inside the cluster, as a theme space-scale index (3 = 8px). */
export const ADMIN_SHELL_BRAND_GAP = 3;

/** Weight of the shell title (hed2 / mono14). `AdminHeaderBar`, `AdminShellBrand` and
 *  `SectionSwitcherDropdown`'s trigger all read it, so a plain title and a dropdown title match. */
export const ADMIN_SHELL_TITLE_FONT_WEIGHT = 600;

/** Horizontal inset of the shell title's text, as a theme space-scale index (2 = 6px). It is
 *  `SectionSwitcherDropdown`'s trigger padding (room for its hover pill); plain titles take it as
 *  left padding, so title text sits the same distance from the logo whichever one an area has. */
export const ADMIN_SHELL_TITLE_INSET_X = 2;

/** Hamburger + Joy logo sizing passed to `BurgerLogoTrigger`. The logo is the brand's XS cut,
 *  whose rounder details hold up at this size; it fills its 27×17 box exactly, so the width is
 *  height × 27/17. The 1.5px nudge optically centres it against the 24px hamburger. */
export const ADMIN_SHELL_BURGER_LOGO = {
  hamburgerSize: 24,
  logoMark: 'xs',
  logoWidth: 34.94,
  logoHeight: 22,
  logoTranslateY: 1.5,
} as const;
